import { useGetUserSubscription } from '@forwardflow/hooks/customHooks'
import { useUpdatePaymentModalStore } from '@forwardflow/store/modal/updatePaymentModal'
import { Skeleton } from 'antd'

export const SavedCards = () => {
   const { data, isLoading } = useGetUserSubscription()
   const { openUpdatePaymentModal } = useUpdatePaymentModalStore()

   const cardNumber = data?.cardDetails?.cardNumber || '**** **** **** ****'
   const nameOnCard = data?.cardDetails?.nameOnCard || ''
   const expiry = data?.cardDetails?.expMonth && data?.cardDetails?.expYear
      ? `${String(data.cardDetails.expMonth).padStart(2, '0')}/${String(data.cardDetails.expYear).slice(-2)}`
      : ''

   return (
      <div className="flex-1">
         <p className="font-medium mb-5">Saved Card</p>
         {!isLoading ? (
            <div className="flex flex-col">
               <div className="relative rounded-2xl overflow-hidden bg-gradient-to-br from-[#9061DA] to-[#7044B4] p-6 min-h-[220px] flex flex-col justify-between">
                  {/* Decorative circle */}
                  <div className="absolute -top-8 -right-8 w-40 h-40 rounded-full bg-white/10" />
                  <div className="absolute top-12 right-12 w-24 h-24 rounded-full bg-white/[0.06]" />

                  <div className="w-8 h-6 rounded bg-white/20 border border-white/30" />

                  <div>
                     <p className="text-white font-medium text-lg tracking-[0.2em] mb-4">{cardNumber}</p>
                     <div className="flex items-end justify-between">
                        <div>
                           <p className="text-white/90 text-xs font-medium uppercase">{nameOnCard}</p>
                           <p className="text-white/60 text-xs">Expires {expiry}</p>
                        </div>
                        <div className="flex gap-1">
                           <div className="w-6 h-6 rounded-full bg-white/40" />
                           <div className="w-6 h-6 rounded-full bg-white/25 -ml-2" />
                        </div>
                     </div>
                  </div>
               </div>
               <button
                  onClick={openUpdatePaymentModal}
                  className="mt-3 w-full py-3 rounded-xl bg-primary/20 hover:bg-primary/30 border border-primary/30 text-white text-sm font-medium transition-colors flex items-center justify-center gap-2"
               >
                  🔧 Change Card
               </button>
            </div>
         ) : (
            <div>
               <Skeleton active className="my-6" />
               <Skeleton active />
            </div>
         )}
      </div>
   )
}
